

export function prettyDate(d: number) {
	return new Intl.DateTimeFormat('default', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	}).format(d * 1000)
}

export function prettyMoney(price: {amount: number, currency: string}) {
	return new Intl.NumberFormat('default',
		{ style: 'currency', currency: price.currency }
	).format(price.amount)
}

export function daysUntil(timestamp: number): number {
	const now = new Date().getTime() / 1000
	const diff =  timestamp - now
	const days = diff / (60 * 60 * 24)
	return Math.round(days)
}

export function monthsUntil(timestamp: number): number {
	const now = new Date().getTime() / 1000
	const diff =  timestamp - now
	const months = diff / (60 * 60 * 24 * 30.5)
	return Math.round(months)
}


export function returnToActivity() {
	window.location.replace(
		window.location.origin + "/login/ReturnToActivity.do"
	)
}


export function returnToSystemHomepage() {
	window.location.replace(window.location.origin)
}